export default __webpack_public_path__ + "assets/images/decor.3e7a15.avif";